import moment from 'moment'

import services from '@/services/ascentiaServiceIndex'
import { FILTER_CONSTS as FC } from '../consts'

const state = {
  filter: {},
}

const getters = {
  parameterFilters: state => {
    return (
      state.filter && state.filter.parameterFilters
        ? state.filter
        : { parameterFilters: [] }
    ).parameterFilters.map(pf => {
      return {
        ...pf,
        deptDate: moment().toDate(),
      }
    })
  },
}

const mutations = {
  [FC.UPDATE_FILTER]: (state, data) => (state.filter = data),
}

const actions = {
  async [FC.SAVE_FILTER]({ commit, state }, { key, filter }) {
    await services.filter.saveData('filterUpdate', {
      key,
      filter,
      filterCollection: state.filter,
    })
    const filters = await services.filter.getData('filter')
    commit(FC.UPDATE_FILTER, filters)
  },
  async [FC.CLEAR_FILTER]({ commit, state }, { key, id }) {
    await services.filter.deleteData('filterDelete', {
      key,
      ids: [id],
      filterCollection: state.filter,
    })
    const filters = await services.filter.getData('filter')
    commit(FC.UPDATE_FILTER, filters)
  },
  async [FC.GET_FILTER]({ commit }) {
    const filters = await services.filter.getData('filter')
    commit(FC.UPDATE_FILTER, filters)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
